<!-- src/app/upload-file-modal/upload-file-modal.component.html -->
<div class="modal-header">
    <h5 class="modal-title">Upload File</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
  </div>
  
  <div class="modal-body">
    <div class="upload-container">
      <div class="upload-area"
           [ngClass]="{'drag-active': dragActive}"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">
        
        <div class="upload-icon">
          <i class="bi bi-cloud-arrow-up"></i>
        </div>
        
        <div class="upload-text">
          <p>Drag and drop your CSV file here</p>
          <p>Or</p>
          <button type="button" class="btn btn-primary" (click)="browseFiles()">Browse Files</button>
          <p class="file-info">Only CSV files are allowed. Max 5 files.</p>
        </div>
        
        <input #fileInput type="file" hidden accept=".csv" multiple (change)="onFileChange($event)">
      </div>
      
      <div class="selected-files" *ngIf="files.length > 0">
        <h6>Selected Files:</h6>
        <div class="file-list">
          <div class="file-item" *ngFor="let file of files; let i = index">
            <div class="file-info">
              <i class="bi bi-file-earmark-text"></i>
              <span>{{ file.name }}</span>
            </div>
            <button class="btn btn-sm btn-outline-danger" (click)="removeFile(i)">
              <i class="bi bi-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
    <button type="button" 
            class="btn btn-primary" 
            [disabled]="files.length === 0"
            (click)="importLeads()">
      Import
    </button>
  </div>